import _objectSpread from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Client, getSDKSource, applySdkMetadata, _INTERNAL_flushLogsBuffer, addAutoIpAddressToUser, addAutoIpAddressToSession } from '@sentry/core';
import { eventFromException as _eventFromException, eventFromMessage as _eventFromMessage } from './eventbuilder.js';
import { WINDOW } from './helpers.js';
var DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */

var BrowserClient = /*#__PURE__*/function (_Client) {
  _inherits(BrowserClient, _Client);

  var _super = _createSuper(BrowserClient);

  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  function BrowserClient(options) {
    var _this;

    _classCallCheck(this, BrowserClient);

    var opts = _objectSpread({
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: true
    }, options);

    var sdkSource = WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(opts, 'browser', ['browser'], sdkSource);
    _this = _super.call(this, opts); // eslint-disable-next-line @typescript-eslint/no-this-alias

    var client = _assertThisInitialized(_this);

    var _client$_options = client._options,
        sendDefaultPii = _client$_options.sendDefaultPii,
        _experiments = _client$_options._experiments;
    var enableLogs = _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableLogs;

    if (opts.sendClientReports && WINDOW.document) {
      WINDOW.document.addEventListener('visibilitychange', function () {
        if (WINDOW.document.visibilityState === 'hidden') {
          _this._flushOutcomes();

          if (enableLogs) {
            _INTERNAL_flushLogsBuffer(client);
          }
        }
      });
    }

    if (enableLogs) {
      client.on('flush', function () {
        _INTERNAL_flushLogsBuffer(client);
      });
      client.on('afterCaptureLog', function () {
        if (client._logFlushIdleTimeout) {
          clearTimeout(client._logFlushIdleTimeout);
        }

        client._logFlushIdleTimeout = setTimeout(function () {
          _INTERNAL_flushLogsBuffer(client);
        }, DEFAULT_FLUSH_INTERVAL);
      });
    }

    if (sendDefaultPii) {
      client.on('postprocessEvent', addAutoIpAddressToUser);
      client.on('beforeSendSession', addAutoIpAddressToSession);
    }

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BrowserClient, [{
    key: "eventFromException",
    value: function eventFromException(exception, hint) {
      return _eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "eventFromMessage",
    value: function eventFromMessage(message) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var hint = arguments.length > 2 ? arguments[2] : undefined;
      return _eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, currentScope, isolationScope) {
      event.platform = event.platform || 'javascript';
      return _get(_getPrototypeOf(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, currentScope, isolationScope);
    }
  }]);

  return BrowserClient;
}(Client);

export { BrowserClient };